import React, { memo } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'

interface RuleProps {
    activityThresholdValue: number
}

function index(props: RuleProps) {
    const { t } = useTranslation()
    return (
        <div className='cmp-rule'>
            {new Array(2).fill(0).map((_, i) =>
                <span key={i}>{t(`SupportStars.Rule.Rule${i}`, { APP: process.env.REACT_APP_DISPLAY_NAME, num: props.activityThresholdValue })}</span>
            )}
        </div>
    )
}

export default memo(index)